import { Button, Dialog, Grid, Slide, Typography } from '@mui/material';
import React from 'react';
import {
  colorLinkGrey,
  colorPrimary,
  colorTextBlack
} from '../../../config/theme';
import { QUESTION_COMPLETE } from '../../../utils/imageUrls';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const QuestionCompleteModal = ({
  isOpen,
  handleClose,
  isQuizInVideo = false,
  trueCount = 0
}) => {
  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={isOpen || false}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose(event, reason);
        }
      }}
      TransitionComponent={Transition}
      disableEscapeKeyDown
      scroll="body"
      className="custom-dialog"
    >
      <div
        style={{
          padding: '40px',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={QUESTION_COMPLETE}
            alt="PDF thumbnail"
            style={{
              width: '90px',
              height: '90px'
            }}
          />
        </div>
        <Typography
          style={{
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: '26px',
            fontFamily: 'Lato',
            color: colorLinkGrey,
            textAlign: 'center',
            marginTop: '10px',
            marginBottom: '10px'
          }}
        >
          {isQuizInVideo
            ? 'Congratulations on completing the quiz!'
            : 'Congratulations for completing the Flashcard.'}
        </Typography>
        {!isQuizInVideo && (
          <Typography
            style={{
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '26px',
              fontFamily: 'Lato',
              color: colorLinkGrey,
              textAlign: 'center',
              marginBottom: '20px'
            }}
          >
            Explore the other flashcard content available on our platform.
          </Typography>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Button
            size="small"
            color="primary"
            variant="contained"
            sx={{
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: colorTextBlack,
              borderWidth: '2px',
              height: '42px',
              width: '83px'
            }}
            onClick={handleClose}
          >
            Ok
          </Button>
        </div>
        {/*  */}
      </div>
    </Dialog>
  );
};

export default QuestionCompleteModal;
